/**
 * SMS Verification Service
 * Calls backend API for phone number verification via Twilio Verify
 */

import { apiClient } from '../api/client';

export interface SendSmsResult {
  success: boolean;
  message?: string;
  rate_limited?: boolean;
  remaining?: number;
}

export interface VerifySmsResult {
  success: boolean;
  message?: string;
  phone_number?: string;
  verify_token?: string;
}

/**
 * Format phone number to international format
 */
export const formatPhoneNumber = (
  countryCode: string,
  phoneNumber: string
): string => {
  const cleanedPhone = phoneNumber.replace(/[^\d]/g, '');
  let finalPhone = cleanedPhone;
  if (countryCode === '+886' && cleanedPhone.startsWith('0')) {
    finalPhone = cleanedPhone.substring(1);
  }
  return `${countryCode}${finalPhone}`;
};

/**
 * Send SMS verification code via backend API
 */
export const sendSmsCode = async (
  phoneNumber: string
): Promise<SendSmsResult> => {
  try {
    // apiClient interceptor already returns response.data
    const data = await apiClient.post('/api/sms/send', {
      phone_number: phoneNumber,
    });
    return data as any;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || 'Failed to send verification code',
    };
  }
};

/**
 * Verify SMS code via backend API
 */
export const verifySmsCode = async (
  phoneNumber: string,
  code: string
): Promise<VerifySmsResult> => {
  try {
    // apiClient interceptor already returns response.data
    const data = await apiClient.post('/api/sms/verify', {
      phone_number: phoneNumber,
      code: code,
    });
    return data as any;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || 'Verification failed',
    };
  }
};
